import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {ChoiceDestination} from 'app/tasks/components/ProcedureTaskPage/CheckableChoices';
import {gt} from 'app/utils/i18n';

import {StepDecisionTitle, StyledStepContentSeparatorDiv} from './structures';

import type {AttachedChoiceType} from 'app/general/types';
import type {AnyStepType} from 'sweet-types';

type Props = {
  choices?: Array<AttachedChoiceType>;
  steps: Array<AnyStepType>;
  edit: boolean;
  onClick?: (event: React.MouseEvent<any>) => any;
};

export const ViewableChoices = ({choices, steps, edit, onClick}: Props) => {
  return choices != null && choices.length > 0 ? (
    <StyledStepContentSeparatorDiv className="choices">
      <StepDecisionTitle />
      <ul className="list-group">
        {choices.map((choice) => {
          const LiNode = (
            <ChoiceDestination
              isChecked={false}
              key={choice.id}
              choice={choice}
              steps={steps}
              disabled={edit}
              userIndicator={null}
              onClick={onClick}
            />
          );

          if (edit) {
            return LiNode;
          } else {
            return (
              <LazyTooltip
                key={choice.id}
                placement="top"
                tooltip={gt(
                  'Start this procedure to begin checking off steps.'
                )}
              >
                {LiNode}
              </LazyTooltip>
            );
          }
        })}
      </ul>
    </StyledStepContentSeparatorDiv>
  ) : null;
};
